import z from "zod";

const validUrlRegex = /^https?:\/\/[\w-]+(\.[\w-]+)+[/#?]?.*$/;

const baseSchema = {
  email: z
    .string()
    .trim()
    .refine(
      val => val === undefined || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
      {
        message: "Invalid email format.",
      }
    ),
  websiteUrl: z
    .string()
    .max(255, { message: "Website must be at most 255 characters." })
    .trim()
    .nullable()
    .optional()
    .refine(val => !val || validUrlRegex.test(val), {
      message: "Website must start with http:// or https://",
    }),
  socialLinks: z
    .array(
      z.object({
        type: z.string().trim().optional().nullable(),
        url: z.string().trim().optional(),
      })
    )
    .max(5, { message: "Maximum 5 social links allowed." })
    .refine(
      arr => {
        const profiles = arr.map(item => item.type);
        return new Set(profiles).size === profiles.length;
      },
      { message: "Duplicate social profiles are not allowed." }
    )
    .optional(),
  connectedAccounts: z.array(z.string()).optional(),
};

export const FormSchema = z.object(baseSchema);

export type BrandContactsType = z.infer<typeof FormSchema>;
